import { Component, OnInit } from '@angular/core';
import { AppConstants } from '../../config.service';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from 'src/app/auth.service';

@Component({
  selector: 'app-search-components',
  templateUrl: './search-components.component.html',
  styleUrls: ['./search-components.component.scss']
})
export class SearchComponentsComponent implements OnInit {


  userInfo: any;

  searchComponentData : any = {};
  constructor(
    private appConstants: AppConstants,
    private keycloakService: KeycloakService,
    private authService : AuthService
  ) {
  }

  
  async getSearchComponentData()
  {

    let permissions : any = {
      cancelSelections : await this.authService.checkRoleExist('cancelSelections'),
      markSelectionsSent : await this.authService.checkRoleExist('markSelectionsSent'),
      downloadSelectionNotices : await this.authService.checkRoleExist('downloadSelectionNotices'),
      emailSelectionNotices : await this.authService.checkRoleExist('emailSelectionNotices'),
      createSelectionLetters : await this.authService.checkRoleExist('createSelectionLetters'),
      candeleteSelections : await this.authService.checkRoleExist('deleteSelections'),
      canCancelComponents : await this.authService.checkRoleExist('cancelComponents'),
      }

    let modifiedObj = {};
    modifiedObj['endpoints'] = this.appConstants.endPoints;
    modifiedObj['userdetails'] = this.userInfo;
    modifiedObj['permissions'] = permissions
    this.searchComponentData = {...{},...modifiedObj}

    
    this.getToken();

    setInterval(() => {
      this.getToken()
    }, 1000);
  }


  sendToken: any = {};
async getToken() {
  let token
  if (await this.keycloakService.isLoggedIn()) {
    token = await this.keycloakService.getToken();
    this.sendToken = Object.assign({}, {
      token: token
    })
  }
}

  /* userInfo: any; */
 ngOnInit() {
       this.isLoading = true
          const user = this.appConstants.userDetails
          this.userInfo = user;
          this.getSearchComponentData()
  }

  isLoading : boolean = false
  loadingEvent(event){
    if(event && event.detail)
     this.isLoading = false
  }

  
}